import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { AccountService } from "src/app/services/account.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { Security } from "src/app/utils/security.util";
import { APP_SETTINGS } from "src/environments/environment";
import Swal from "sweetalert2";
import { PodeAcessarViewModel } from "../../domain/viewmodels.models";

@Component({
  selector: "app-login",
  templateUrl: "./login-page.component.html",
  styles: [],
})
export class LoginPageComponent implements OnInit {
  public form: FormGroup;
  public messageError: string;
  public acessando = false;
  public msgUsuarioDesativado = "";

  public nomeCliente = APP_SETTINGS.nomeCliente;
  public parceiroComercial = APP_SETTINGS.parceiroComercial;
  public msgTelaLogin = APP_SETTINGS.msgTelaLogin;

  slideConfig2 = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0",
    slidesToShow: 1,
    speed: 500,
    dots: true,
  };

  constructor(
    private service: AccountService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
  ) {
    this.form = this.formBuilder.group({
      username: [""],
      password: [""],
    });
  }

  ngOnInit() {
    const token = Security.getToken();
  }

  submit() {
    if (this.validForm()) {
      this.acessando = true;

      this.service.authenticate(this.form.value).subscribe(
        (data: any) => {
          if (data.user != null) {
            if (data.user.ativo) {
              this.usuarioService
                .getUsuarioAutorizacoes(data.user.id)
                .subscribe((autorizacoes) => {
                  if (data.user.nivel === 5 || autorizacoes.length > 0) {
                    if (
                      data.user.nivel === 5 ||
                      autorizacoes.some((t) => t.podeAcessar)
                    ) {
                      this.setUser(data.user, data.token, autorizacoes); // usuário existe, está ativo e tem ao menos uma autorização
                    } else {
                      Swal(
                        "",
                        "usuário não tem acesso a nenhuma tela",
                        "warning",
                      );
                    }
                  } else {
                    Swal("", "usuário não possui autorizacoes", "warning");
                  }
                });
            } else {
              Swal({
                title: "",
                html: `Usuário <b>${data.user.nome}</b> está desativado!`,
                type: "error",
              });
            }
          } else {
            Swal("", data.notifications[0].message, "warning");
          }
        },

        (err: any) => {
          if (err.status === 500) {
            Swal({
              title: "Erro Interno no Servidor",
              html: `status: <b>${err.status}</b><br />Ocorreu um erro de processamento no servidor`,
              type: "error",
            });
          } else {
            Swal({
              title: "Erro de Conexão",
              html: `Não foi possível se conectar ao servidor`,
              type: "error",
            });
          }
        },
        () => (this.acessando = false),
      );
    } else {
      this.acessando = false;
    }
  }

  setUser(user, token, autorizacoes?: UsuarioAutorizacoes[]) {
    let podeAcessar: PodeAcessarViewModel = new PodeAcessarViewModel(
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    );

    if (autorizacoes != null && autorizacoes.length > 0) {
      let Usuario = autorizacoes.find(
        (a) => a.rota == "usuario" && !a.especifica,
      );
      let EmitirOS = autorizacoes.find(
        (a) => a.rota == "emitir-os" && !a.especifica,
      );
      let EmitirOsAutomatica = autorizacoes.find(
        (a) => a.rota == "emitir-os-automatica" && !a.especifica,
      );
      let TratarOSAvaliada = autorizacoes.find(
        (a) => a.rota == "tratar-os-avaliada" && !a.especifica,
      );
       let VistoDeExecucao = autorizacoes.find(
        (a) => a.rota == "visto-de-execucao" && !a.especifica,
      );
      let ValidarOS = autorizacoes.find(
        (a) => a.rota == "validar-os" && !a.especifica,
      );
      let ConsultarOs = autorizacoes.find(
        (a) => a.rota == "consultar-os-emitida" && !a.especifica,
      );
      let HistoricoEquipamento = autorizacoes.find(
        (a) => a.rota == "historico-equipamento" && !a.especifica,
      );
      let SatisfacaoServico = autorizacoes.find(
        (a) => a.rota == "satisfacao-servico" && !a.especifica,
      );
      let Dashboard = autorizacoes.find(
        (a) => a.rota == "dashboard" && !a.especifica,
      );
      let QuantitativoServicos = autorizacoes.find(
        (a) => a.rota == "quantitativo-servico" && !a.especifica,
      );
      let Irregularidade = autorizacoes.find(
        (a) => a.rota == "irregularidade" && !a.especifica,
      );
      let Empreiteira = autorizacoes.find(
        (a) => a.rota == "empreiteira" && !a.especifica,
      );
      let FecharOs = autorizacoes.find(
        (a) => a.rota == "fechar-os" && !a.especifica,
      );
      let Fabricante = autorizacoes.find(
        (a) => a.rota == "fabricante" && !a.especifica,
      );
      let Estoque = autorizacoes.find(
        (a) => a.rota == "estoque" && !a.especifica,
      );
      let Material = autorizacoes.find(
        (a) => a.rota == "material" && !a.especifica,
      );
      let Categoria = autorizacoes.find(
        (a) => a.rota == "categoria" && !a.especifica,
      );
      let Funcionario = autorizacoes.find(
        (a) => a.rota == "funcionario" && !a.especifica,
      );
      let Equipamento = autorizacoes.find(
        (a) => a.rota == "equipamento" && !a.especifica,
      );
      let Local = autorizacoes.find((a) => a.rota == "local" && !a.especifica);
      let AreaTecnica = autorizacoes.find(
        (a) => a.rota == "areatecnica" && !a.especifica,
      );

      let Rotina = autorizacoes.find(
        (a) => a.rota == "rotina" && !a.especifica,
      );
      let Atividade = autorizacoes.find(
        (a) => a.rota == "atividade" && !a.especifica,
      );
      let CalendarioMensal = autorizacoes.find(
        (a) => a.rota == "calendario-mensal" && !a.especifica,
      );
      let UsuarioAlterarSenha = autorizacoes.find(
        (a) => a.rota == "alterar-senha" && !a.especifica,
      );
      let SolicitarSpv = autorizacoes.find(
        (a) => a.rota == "solicitar-spv" && !a.especifica,
      );
      let AcompanharSpv = autorizacoes.find(
        (a) => a.rota == "acompanhar-spv" && !a.especifica,
      );
      let AvaliarSpv = autorizacoes.find(
        (a) => a.rota == "avaliar-spv" && !a.especifica,
      );
      let ProgramarServico = autorizacoes.find(
        (a) => a.rota == "programar-servico" && !a.especifica,
      );
      let SolicitarPt = autorizacoes.find(
        (a) => a.rota == "solicitar-pt" && !a.especifica,
      );
      let AcompanharPt = autorizacoes.find(
        (a) => a.rota == "acompanhar-pt" && !a.especifica,
      );

      let CentroCusto = autorizacoes.find(
        (a) => a.rota == "centro-custo" && !a.especifica,
      );
      let ClasseEquipamento = autorizacoes.find(
        (a) => a.rota == "classe-equipamento" && !a.especifica,
      );
      let GrupoLocalNivel = autorizacoes.find(
        (a) => a.rota == "grupo-local-nivel" && !a.especifica,
      );
      let Prioridade = autorizacoes.find(
        (a) => a.rota == "prioridade" && !a.especifica,
      );
      let TipoMaterial = autorizacoes.find(
        (a) => a.rota == "tipo-material" && !a.especifica,
      );

      let EquipamentoRD = autorizacoes.find(
        (a) => a.rota == "equipamento-rd	" && !a.especifica,
      );
      let ModeloRD = autorizacoes.find(
        (a) => a.rota == "modelo-rd" && !a.especifica,
      );
      let EmitirRD = autorizacoes.find(
        (a) => a.rota == "emitir-rd" && !a.especifica,
      );
      let EntradaMaterial = autorizacoes.find(
        (a) => a.rota == "entrada-material" && !a.especifica,
      );
      let EntradaPeriodo = autorizacoes.find(
        (a) => a.rota == "entrada-periodo" && !a.especifica,
      );

      podeAcessar.Usuario = Usuario != undefined ? Usuario.podeAcessar : false;
      podeAcessar.EmitirOS =
        EmitirOS != undefined ? EmitirOS.podeAcessar : false;
      podeAcessar.EmitirOsAutomatica =
        EmitirOsAutomatica != undefined
          ? EmitirOsAutomatica.podeAcessar
          : false;
      podeAcessar.TratarOSAvaliada =
        TratarOSAvaliada != undefined ? TratarOSAvaliada.podeAcessar : false;
      podeAcessar.VistoDeExecucao =
        VistoDeExecucao != undefined ? VistoDeExecucao.podeAcessar : false;
              podeAcessar.ValidarOS =
        ValidarOS != undefined ? ValidarOS.podeAcessar : false;
      podeAcessar.ConsultarOs =
        ConsultarOs != undefined ? ConsultarOs.podeAcessar : false;
      podeAcessar.HistoricoEquipamento =
        HistoricoEquipamento != undefined
          ? HistoricoEquipamento.podeAcessar
          : false;
      podeAcessar.SatisfacaoServico =
        SatisfacaoServico != undefined ? SatisfacaoServico.podeAcessar : false;
      podeAcessar.Dashboard =
        Dashboard != undefined ? Dashboard.podeAcessar : false;
      podeAcessar.QuantitativoServicos =
        QuantitativoServicos != undefined
          ? QuantitativoServicos.podeAcessar
          : false;
      podeAcessar.Irregularidade =
        Irregularidade != undefined ? Irregularidade.podeAcessar : false;
      podeAcessar.Empreiteira =
        Empreiteira != undefined ? Empreiteira.podeAcessar : false;
      podeAcessar.FecharOs =
        FecharOs != undefined ? FecharOs.podeAcessar : false;
      podeAcessar.Fabricante =
        Fabricante != undefined ? Fabricante.podeAcessar : false;
      podeAcessar.Estoque = Estoque != undefined ? Estoque.podeAcessar : false;
      podeAcessar.Material =
        Material != undefined ? Material.podeAcessar : false;
      podeAcessar.TipoMaterial =
        TipoMaterial != undefined ? TipoMaterial.podeAcessar : false;
      podeAcessar.EntradaMaterial =
        EntradaMaterial != undefined ? EntradaMaterial.podeAcessar : false;
      podeAcessar.EntradaPeriodo =
        EntradaPeriodo != undefined ? EntradaPeriodo.podeAcessar : false;

      podeAcessar.Categoria =
        Categoria != undefined ? Categoria.podeAcessar : false;
      podeAcessar.Funcionario =
        Funcionario != undefined ? Funcionario.podeAcessar : false;
      podeAcessar.Equipamento =
        Equipamento != undefined ? Equipamento.podeAcessar : false;
      podeAcessar.Local = Local != undefined ? Local.podeAcessar : false;
      podeAcessar.AreaTecnica =
        AreaTecnica != undefined ? AreaTecnica.podeAcessar : false;

      podeAcessar.Rotina = Rotina != undefined ? Rotina.podeAcessar : false;
      podeAcessar.Atividade =
        Atividade != undefined ? Atividade.podeAcessar : false;
      podeAcessar.CalendarioMensal =
        CalendarioMensal != undefined ? CalendarioMensal.podeAcessar : false;
      podeAcessar.UsuarioAlterarSenha =
        UsuarioAlterarSenha != undefined
          ? UsuarioAlterarSenha.podeAcessar
          : false;
      podeAcessar.SolicitarSpv =
        SolicitarSpv != undefined ? SolicitarSpv.podeAcessar : false;
      podeAcessar.AcompanharSpv =
        AcompanharSpv != undefined ? AcompanharSpv.podeAcessar : false;
      podeAcessar.AvaliarSpv =
        AvaliarSpv != undefined ? AvaliarSpv.podeAcessar : false;
      podeAcessar.ProgramarServico =
        ProgramarServico != undefined ? ProgramarServico.podeAcessar : false;
      podeAcessar.SolicitarPt =
        SolicitarPt != undefined ? SolicitarPt.podeAcessar : false;
      podeAcessar.AcompanharPt =
        AcompanharPt != undefined ? AcompanharPt.podeAcessar : false;

      podeAcessar.CentroCusto =
        CentroCusto != undefined ? CentroCusto.podeAcessar : false;
      podeAcessar.ClasseEquipamento =
        ClasseEquipamento != undefined ? ClasseEquipamento.podeAcessar : false;
      podeAcessar.GrupoLocalNivel =
        GrupoLocalNivel != undefined ? GrupoLocalNivel.podeAcessar : false;
      podeAcessar.Prioridade =
        Prioridade != undefined ? Prioridade.podeAcessar : false;

      podeAcessar.EquipamentoRD =
        EquipamentoRD != undefined ? EquipamentoRD.podeAcessar : false;
      podeAcessar.ModeloRD =
        ModeloRD != undefined ? ModeloRD.podeAcessar : false;
      podeAcessar.EmitirRD =
        EmitirRD != undefined ? EmitirRD.podeAcessar : false;
    }

    Security.set(user, token, autorizacoes, podeAcessar);
    this.router.navigate(["/home"]);
  }

  validForm() {
    let valid = true;
    this.msgUsuarioDesativado = "";

    if (this.form.get("username").value === "") {
      this.form.get("username").setErrors({ isNotValidUserName: true });
      valid = false;
    }

    if (this.form.get("password").value === "") {
      this.form.get("password").setErrors({ isNotValidPassword: true });
      valid = false;
    }

    return valid;
  }
}
